<template>
  <div class="c-box mb-16 mt-px">
    <div class="p-pnt">
      <div class="menu-main-content">
        <section>
          <div class="main-top">
            <div class="main-top-left">
              <a
                class="inline-flex items-center"
                href="javascript:void(0)"
                @click="backPath"
              >
                <i class="icon icon-bor-arrow-left pr-2" style="font-size: 10px" />
                <span class="text-black">プラン一覧に戻る</span>
              </a>
            </div>
          </div>
        </section>

        <!-- /* Carousel */ -->
        <section class="lg:pl-4">
          <div class="pnl-title flex items-start">
            <!-- <div class="label label-primary mt-2 mr-4" v-if="checkFiveDay()">NEW</div> -->
            <h3 class="two-lines-ellipsis" v-if="planBasicInfo" ref="dpPlanNm">
              {{ planBasicInfo.planNm }}
            </h3>
          </div>
          <div class="main-demo">
            <div class="menu-carousel">
              <BasicCarousel
                class="mb-4 lg:hidden"
                :isShowIndicator="false"
                :images="get(planBasicInfo, 'slides', [])"
              />

              <div
                class="slide-images-mobile hidden lg:flex overflow-x-auto object-contain"
                v-if="planBasicInfo && planBasicInfo.slides && planBasicInfo.slides.length > 0"
              >
                <img
                  :src="img.imageUrl"
                  :alt="img.imageExplanation"
                  v-for="(img, idx) in planBasicInfo.slides"
                  :key="`plan-img-${idx}`"
                />
              </div>
            </div>

            
        <div class="p-menus-no-plan-detail__contents__right">
          <div
            class="p-menus-no-plan-detail__contents__description margin-top"
              v-if="getPlanLeadCopy"
              v-html="getPlanLeadCopy.replaceAll('\n', '<br>')"
            ></div>

          <!-- <p
            v-if="isPointExchange"
            class="p-menus-no-plan-detail__contents__description"
          >
            {{ planBasicInfo.pointExchg.pointExchgTxtGuidance }}
          </p> -->
          <p
            v-if="showBenepoValue && showBenepoValue.value"
            class="p-menus-no-plan-detail__contents__assignmentPoint"
          >
          {{ showBenepoValue.value }}{{ showBenepoValue.prefix }}ベネポ付与
          </p>

        </div>
          </div>
          <div
            v-if="planBenefit && !isEntertainment && checkBigDiv"
            class="p-menus-no-plan-detail__block"
            >
              <h2
                class="p-menus-no-plan-detail__block__title c-title2"
                id="p-menus-no-plan-detail__member__benefit"
              >
                会員特典
              </h2>

              <div class="menu-price flex mb-4">
              <div class="price-content">
                <p class="text-black" v-if="getBenefitHeading">{{ getBenefitHeading }}</p>
                <span
                  class="font-bold"
                  v-if="getBenefitContent"
                  v-html="getBenefitContent.replaceAll('\n', '<br>')"
                />
              </div>
            </div>
      
              <ul class="p-menus-no-plan-detail__contents__bene-status">
                <template v-for="item in getPlanIcons">
                  <li :key="item.key" v-if="item.isAvailable || (item.iconCd && item.iconNm)" :class="item.isKyutoku ? 'kyutoku' : ''"  >
                    {{ item.iconNm }}
                  </li>
                </template>
                <template v-if="showSubsidy" >
                  <template v-for="item in iconData">
                    <li
                      :key="item.key"
                      :class="[
                        item.iconNm !== 'カフェ'
                          ? 'mr-1'
                          : 'mr-1 cafe-icon'
                      ]"
                    >
                      {{ item.iconNm }}
                    </li>
                  </template>
                </template>
              </ul>
              <div v-if="isCelebration">
                <a>会員特典の詳細はこちら</a>
              </div>
                      <!-- 特典備考 -->
              <!-- p-menus-no-detail-infomation__innerのグラデーションをなくすためにinner-accordionを記述 -->
              <div
                class="
                  p-menus-no-detail-infomation__inner
                  plna-detail-infomation
                "
                :style="{ height: openHeight + 'px' }"
              >
                <div ref="infomationText">
                  <div
                    v-if="
                      planDetail &&
                      planDetail.benefitImportantPoints &&
                      planDetail.benefitImportantPoints.length > 0
                    "
                    class="p-menus-no-plan-detail__member__note2 annotation"
                  >
                    <div v-for="item in planDetail.benefitImportantPoints" :key="item.id">
                      <p class="p-menus-no-plan-detail__member__note2__title">
                        {{ item.title }}
                      </p>
                      <p v-if="item.content" v-html="$utils.htmlText(item.content)"></p>
                    </div>
                    <a
                      v-if="shopingDataLink"
                      class="item-link"
                      target="_blank"
                      :href="shopingDataLink.linkUrl"
                      >{{ shopingDataLink.linkNm
                      }}<Icon
                        name="action_external_link"
                        width="18"
                        height="18"
                        class="icon"
                    /></a>
                  </div>
                </div>
            </div>
            <!-- アコーディオン「閉じる」「注意事項を見る」 -->
            <div
              class="p-menus-no-detail-infomation__more precautions-margin"
              :class="{ 'p-menus-no-detail-infomation__more--disabled': !isShowToggle }"
              v-if="
                planDetail&&
                planDetail.benefitImportantPoints &&
                planDetail.benefitImportantPoints.length > 0
              "
            >
              <a
                href="javascript:;"
                class="c-text-button c-text-button--sm c-text-button--left"
                @click="getHiddenHeight(!isShowInfomation); scrollToTarget(isShowInfomation);"
                >
                {{ isShowInfomation ? "閉じる" : "注意事項を見る" }}
                <Icon
                  :name="isShowInfomation ? 'arrow_up' : 'arrow_down'"
                  width="33px"
                  height="48px"
                  color="gray"
                />
              </a>
            </div>
          </div>
          <!-- 補助クーポン -->
          <MenusSubsidyCouponList
            v-if="canSubsidyFlg && showSubsidy"
            :subsidyData="subsidyData"
          ></MenusSubsidyCouponList>
          <!-- 申込み方法 -->
          <div
            v-if="
              (isDirectApplication ||
                isMerchantApplication ||
                isOtherTextGuide ||
                isConvenienceStore ||
                isCelebrationApplicationOnly)
                // && !showMenuPlanInformationCalendar
            "
            id="application-detail"
            class="p-menus-no-plan-detail__applicationDetails"
          >
            <div class="p-menu-membership-coupon-application">
              <h4 class="p-menu-membership-coupon-application__title">
                お申込み方法
              </h4>
              <!-- 直接申込の場合 -->
              <template v-if="isDirectApplication">
                <MenusDirectApplication
                  :planData="planUsage"
                  @apply="merchantApply"
                />
              </template>


              <!-- 加盟店申込（アフィリエイト）の場合 -->
              <template v-if="isMerchantApplication">
                <MenusMerchantApplication
                  :planData="planUsage"
                  @apply="merchantApply"
                />
              </template>
            </div>
          </div>

        
          <div
            id="p-menus-no-plan-detail_shopping-guide"
            v-if="showMenusLabelList"
            class="p-menus-no-plan-detail__block"
          >
            <h3 class="p-menus-no-plan-detail__block__title c-title2">
              ショッピングガイド
            </h3>
            <MenusLabelList
              :list="shopingData"
              :wide="1"
              :planBasicInfo="planBasicInfo"
              :planId="queryCode.planId"
            />
          </div>
          <!-- インフォメーション -->
          <div
            v-if="planInfomation&&planInfomation.length > 0"
            class="p-menus-no-plan-detail__block border-top-line"
          >
            <h3 class="p-menus-no-plan-detail__block__title c-title2 ">
              インフォメーション
            </h3>
            <MenusInfomation :planInfomation="planInfomation"/>
          </div>
          <div class="divider mb-8 mt-8 sm:mt-0" />
        </section>
      </div>
      <!-- 個人情報同意モーダル -->
      <MenusPersonalInformationConsent
        ref="personal-infomation"
        @agree="orderTour"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable vue/no-unused-components */
import _ from 'lodash'
import get from 'lodash/get'
import moment from "moment";
import plan_utils from '@/mixins/plan_utils'
import func_utils from '@/mixins/func_utils'
import {
  MenuNavigation,
  CarouselThumbnail,
  BoxViewMore,
  SectionContentTitle
} from '@/components/compound'
import { Button, Tag, Calendar, Stepper, Modal } from '@/components/primitive'
import { SAVE_PLAN_DETAIL } from '@/store/modules/plan/actions'
import { getCookieValue } from '@/utils/cookie'
const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')
import MenusPersonalInformationConsent from './PersonalInformationConsent.vue'
import MenusMerchantApplication from './MerchantApplication.vue'
import MenusDirectApplication from './DirectApplication.vue'
import MenusLabelList from './LabelList.vue'
import MenusInfomation from './Infomation.vue'
import MenusSubsidyCouponList from './SubsidyCouponList.vue'

export default {
  name: 'PlanDetail',
  mixins: [plan_utils, func_utils],
  components: {
    Button,
    BoxViewMore,
    Calendar,
    CarouselThumbnail,
    MenuNavigation,
    Tag,
    Stepper,
    SectionContentTitle,
    Modal,
    MenusPersonalInformationConsent,
    MenusMerchantApplication,
    MenusDirectApplication,
    MenusLabelList,
    MenusInfomation,
    MenusSubsidyCouponList
  },
  props: {
    menu: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      acptDtlNo: null,
      loading: false,
      showPreviewImg: false,
      previewImage: [
        {
          imageUrl: '',
          imageExplanation: ''
        }
      ],
      dateFormat: 'YYYY/MM/DD',
      planDetail: null,
      menuInformation: null,
      planBasicInfo: null,
      planIcons: null,
      roomIcons: null,
      planInfomation: null,
      roomBasicInfo: null,
      status: null,
      planRcSttDt: null,
      showGallery: false,
      galleryData: [],
      isLoginedRakuten: false,
      memberBenefits: null,
      benefitImportantPoints: null,
      popupLogin: false,
      planUsage: null,
      description1: 'ログインして',
      description2: 'サービスをご利用ください。',
      pattern: null, // プラン詳細の表示パターン
      patternList: {
        childcareOrCare: 10, // 育児介護
        convenienceStore: 20, // コンビニ
        digiTicketOrDigiCoupon: 30, // デジチケ・デジポン
        direct: 40, // 直接申込
        affiliate: 41, // アフィリエイト
        entertainment: 50, // 興行
        memberCoupon: 60, // 会員証クーポン
        pointExchange: 70, // ポイント交換
        textGuide: 80, // テキスト案内
        celebration: 90 // お祝い
      },
      paymentMethodSelected: null,
      subsidyData: [],
      openHeight: 0,
      isShowToggle:false,
      isShowInfomation:false,
      iconData: [],
      canSubsidyFlg: false, // 補助金利用可能フラグ
      initDataIcon :{
        menu: false,
        plan: false
      }
    }
  },
  async created() {
    const bsjsessionid = getCookieValue(process.env.VUE_APP_SSO_COOKIE_NAME);
    this.status = bsjsessionid?.slice(0, 2);
    this.loadInitData()
    this.$loading.show()
    const planResult = await this.getPlanDetail()
    this.$loading.hide()
    if (!planResult || planResult.error) {
      this.$page.errorHandler(planResult, { navigate: true })
      return
    }
    this.$store.dispatch(SAVE_PLAN_DETAIL, planResult)
    this.planDetail = planResult
    this.initDataIcon.plan = true;
    this.menuInformation = this.planDetail.menuInformation
    this.planBasicInfo = this.planDetail.planBasicInfo
    this.setShowPattern();
    if (this.planBasicInfo) {
      if (
        !Array.isArray(this.planBasicInfo.planImages) ||
        !this?.planBasicInfo.planImages?.length
      ) {
        this.planBasicInfo.planImages = [
          {
            imageUrl: PLACEHOLDER_IMG,
            imageExplanation: ''
          }
        ]
      }
      for (let i = 0; i < this.planBasicInfo?.planImages?.length; i++) {
        if (
          this.planBasicInfo.planImages &&
          (this.planBasicInfo.planImages[i].imageUrl === '' ||
            this.planBasicInfo.planImages[i].imageUrl === null)
        ) {
          this.planBasicInfo.planImages[i].imageUrl = PLACEHOLDER_IMG
        }
      }
      this.planBasicInfo.slides = this.planBasicInfo.planImages.map((item) => {
        return {
          imageUrl: item.imageUrl,
          label: item.imageExplanation
        }
      })
    }
    this.planRcSttDt = this.planDetail?.planBasicInfo?.planRcSttDt
    this.planIcons = this.planDetail?.planIcons
    this.planInfomation = this.planDetail?.planInfomation
    this.planUsage = this.planDetail?.planUsage
  },
  mounted() {
    if(this.planDetail) this.initDataIcon.plan = true;
    if(this.menu) this.initDataIcon.menu = true;
    this.getHiddenHeight();
    window.addEventListener("resize", this.getHiddenHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getHiddenHeight);
  },
  watch: {
    menu: {
      deep: true,
      handler(val) {
        if(val){
          this.initDataIcon.menu = true;
        }
      }
    },
    initDataIcon: {
      deep: true,
      async handler(val) {
        if(val.menu && val.plan){
          if(this.menu?.menuBasicInfo?.extSystemCd && !['jadp','jato'].includes(this.menu.menuBasicInfo.extSystemCd) ) {
            await this.getSubsidy()
            // マッピングアイコン取得にはプラン情報と補助金両方のデータが必要
            if (Array.isArray(this.subsidyData) && this.subsidyData.length > 0) {
              this.getSubsidyIcon(this.subsidyData);
              // 利用可能補助金ありのフラグを立てる
              this.canSubsidyFlg = true;
            }else {
              this.canSubsidyFlg = false;
            }
          }
          this.getCafeIcon();
        }
      }
    }
  },
  computed: {
    loggedIn() {
      // return true
      return this.$auth.loggedIn
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    getPlanLeadCopy() {
      const planLeadCopy = _.get(this.planBasicInfo, 'planLeadCopy', '')
      return planLeadCopy
    },
    getBenefitImportantPoints() {
      const getBenefitImportantPoints = _.get(
        this.planDetail,
        'benefitImportantPoints[0].content',
        ''
      )
      return getBenefitImportantPoints
    },
    getBenefitHeading() {
      const benefitHeading = _.get(this.planDetail, 'memberBenefits[0].benefitHeading')
      return benefitHeading
    },
    getBenefitContent() {
      const benefitContent = _.get(this.planDetail, 'memberBenefits[0].benefitContent')
      return benefitContent
    },
    
    // UPDATE NEW
    shopingDataLink() {
      return this.planDetail?.benefitImportantPoints?.find(
        (item) => +item.infoLev == 3 && item.linkNm && item.linkUrl
      );;
    },
    // デジチケ・デジポン判定
    isDigiticketOrDigiCoupon() {
      return this.pattern == this.patternList.digiTicketOrDigiCoupon;
    },
    // 会員証判定
    isMemberCoupon() {
      return this.pattern == this.patternList.memberCoupon;
    },
    // 直接申込(TEL/MAIL/FAX/WEB予約)判定
    isDirectApplication() {
      return this.pattern == this.patternList.direct;
    },
    // その他テキスト案内判定
    isOtherTextGuide() {
      return this.pattern == this.patternList.textGuide;
    },
    // 興行判定
    isEntertainment() {
      return this.pattern == this.patternList.entertainment;
    },
    // コンビニ判定
    isConvenienceStore() {
      return this.pattern == this.patternList.convenienceStore;
    },
    // 加盟店申込（アフィリエイト）判定
    isMerchantApplication() {
      return this.pattern == this.patternList.affiliate;
    },
    // お祝い判定
    isCelebration() {
      return this.pattern == this.patternList.celebration;
    },
    // お祝い申込専用
    isCelebrationApplicationOnly() {
      return this.isCelebration && this.planUsageDiv != this.CONST_DATA.USAGE_DIV.MEMBERSHIP_COUPON;
    },

    checkBigDiv() {
      return !!this.planDetail?.memberBenefits?.length;
    },

    planBenefit() {
      if (!this.planDetail?.memberBenefits) return [];
      return this.planDetail.memberBenefits;
    },
    planUsageDiv() {
      if (!this.planDetail?.planUsage?.usageDiv) return null;
      return this.planDetail.planUsage.usageDiv;
    },
    // サービス区分の取得
    planServiceDiv() {
      if (!this.planDetail?.planUsage?.srvicDiv) return null;
      return this.planDetail.planUsage.srvicDiv;
    },
    
    queryCode() {
      return {
        menuNo: this.$route.params.menuNo
          ? this.$route.params.menuNo.replace("menuNo=", "")
          : "",
        planId: this.$route.params.planId
          ? this.$route.params.planId.replace("planId=", "")
          : ""
      };
    },
    showBenepoValue() {
      if (!this.planDetail?.benepoReturnInfo?.benepoReturnDiv) return null;
      if (this.planDetail?.benepoReturnInfo?.benepoReturnDiv == this.CONST_DATA.BENEPO_RETURN_DIV.RATE) {
        return {
          value: Number(this.planDetail?.benepoReturnInfo?.benepoReturnRate),
          prefix: "%"
        };
      } else if (this.planDetail?.benepoReturnInfo?.benepoReturnDiv == this.CONST_DATA.BENEPO_RETURN_DIV.FIXED) {
        return {
          value: this.planDetail?.benepoReturnInfo?.benepoReturnFixed,
          prefix: ""
        };
      } else {
        return null;
      }
    },
        // 興行判定
    isEntertainment() {
      return this.pattern == this.patternList.entertainment;
    },
    showSubsidy() {
      /**
       * 46692 補助金表示対象は以下のみ
       * ベネ申込・Web受付不可、コンビニ端末申込、ベネ申込・加盟店手配、紙チケット、ベネ申込・ベネ手配、ｄ、デジタルチケット
       * コンビニ決済の場合は、Famiのみ利用可能
       */
      
      // if (this.planUsageDiv == this.CONST_DATA.USAGE_DIV.NOT_AVAILABLE_WEB ||
      //   (this.planUsageDiv == this.CONST_DATA.USAGE_DIV.CONVENIENCE_STORE_TERMINAL && this.isConvenienceStoreFami) ||
      //   this.planUsageDiv == this.CONST_DATA.USAGE_DIV.APPLY_WITH_MEMBER_STORE ||
      //   this.planUsageDiv == this.CONST_DATA.USAGE_DIV.PAPER_TICKET ||
      //   this.planUsageDiv == this.CONST_DATA.USAGE_DIV.BENEFITS ||
      //   this.isDigiticketOrDigiCoupon
      // ) {
      //   return true;
      // }
      // return false;
      return true;
    },
    showMenusLabelList() {
      const shoppingGuides = get(this.planDetail, "shoppingGuideInfo.shoppingGuides", []);
      return shoppingGuides?.length > 0;
    },
    shopingData() {
      let list = [];
      let type = 1;
      let shoppingGuideInfo = get(this.planDetail, "shoppingGuideInfo.shoppingGuides", []);
      let usageTxtGuidance = get(this.planDetail, "shoppingGuideInfo.usageTxtGuidance", null)
      if (shoppingGuideInfo.length === 0) return list;
      if (shoppingGuideInfo) {
        for (let item of shoppingGuideInfo) {
          const guideValue = get(item, "shoppingGuideValue", null);
          const guideValues = get(item, "shoppingGuideValues", []);
          const shoppingGuideCd = get(item, "shoppingGuideCd", null);
          const linkNm = get(item, "linkNm");
          const linkUrl = get(item, "linkUrl");
          if (guideValue && guideValue.startsWith("http")) {
            type = 2;
          } else if (guideValue) {
            type = 1;
          } else if (guideValues?.length) {
            type = 3;
          }
          list.push({
            label: item.shoppingGuideNm,
            type: type,
            name: guideValue,
            ary: guideValues,
            linkNm,
            linkUrl
          });
          if(shoppingGuideCd === '000209') {
            list.push({
              label: '利用案内',
              type: 1,
              name: usageTxtGuidance,
              ary: null,
              linkNm: null,
              linkUrl: null
            });
          }
        }
      }
      if (shoppingGuideInfo.facilityNm)
        list.push({ label: "店舗名", type: 1, name: facilities.facilityNm });
      return list;
    },
    getPlanIcons() {
      let result =  this.planIcons?.length > 0 ? _.cloneDeep(this.planIcons) : [];
      return result;
    },
    menuInfomation() {
      return this.menu?.menuInfomation
    }
  },
  methods: {
    get,
    loadInitData() {
      const query = _.cloneDeep(this.$route.query)
      if (query.isLoginedRakuten) {
        this.isLoginedRakuten = true
      }
      if (!query.adultHeadCnt) {
        query.adultHeadCnt = 1
      }
    },
    async orderTour() {
      if (!this.loggedIn) {
        this.popupLogin = true
        return
      }
      const extSystemCd = this.menu?.menuBasicInfo?.extSystemCd;
      let orderSite = null
      if (extSystemCd === 'rtdp') {
        orderSite = '1'
      } else if (extSystemCd === 'andp') {
        orderSite = '2'
      } else if (extSystemCd === 'jadp' || extSystemCd === 'jato') {
        orderSite = '3'
      }
      const { menuNo, planId } = this.$route.params
      const data = {
        customerNo: _.get(this.userInfo, 'ssoCustomerNo', null),
        menuNo,
        planId,
        orderSite
      }

      const orderTour = await this.checkOrderTour(data)
      if(orderTour.status === 200 && orderTour?.data) {
        // location.href = orderTour.data
        window.open( orderTour.data, '_blank')
      } else {
        if (window.navigator.userAgent.search(/officialapp/i) !== -1) {
          // アプリセッション切れ対応のため暫定的処理
          this.$toasted.error('アプリではご利用できないプランとなります。お手数ですがブラウザでお申込ください');
        }
        else {
          this.$toasted.error('エラーが発生しました。');
        }
      }
    },

    async checkOrderTour(data) {
      return await this.$repositories('order')
        .checkOrderTour(data)
        .then(
          (result) => result,
          (error) => error
        )
    },

    async getPlanDetail() {
      const { menuNo, planId } = this.$route.params
      const query = this.$route.query
      const result =  await this.$repositories('plan').getDPPlanDetail(menuNo, planId, query);
      return result;
    },
      /**
     * 利用可能補助金取得
     */
     async getCouponData() {
      const result = await this.$repositories('coupon').getSubsidyCouponList({ displayDiv: '2' });
      if (!Array.isArray(result)) {
       return [];
      }
      return result;
    },

    async getSubsidy() {
      let tmpSubsidyData = await this.getCouponData();

      if (!tmpSubsidyData || !Array.isArray(tmpSubsidyData)) {
        return;
      }

      // 保有枚数0枚の補助金は取り除く（nullの場合は利用可）
      tmpSubsidyData = tmpSubsidyData.filter(data => data.remainingCount !== 0);

      // 利用可能な期間内のものに絞り込む
      const subsidyData = this.filterWithinPeriod(tmpSubsidyData);

      // 利用可能補助金のID一覧を作成
      const ids = this.makeSubsidyIdList(subsidyData);

      if (ids.length == 0) return;

      const mapping = await this.getMapping(ids);

      // プランで利用可能な補助金一覧
      this.subsidyData = this.makeSubsidyList(subsidyData, mapping, ids);

    },
    /**
     * 利用可能な期間内のものに絞り込む
     * @param {Array<object>} subsidyList 利用可能な補助金の一覧
     * @return {Array<object>} filterList 利用可能な期間内の補助金の一覧
     */
     filterWithinPeriod(subsidyList) {
      const today = moment().startOf('days') // 日付比較のため.startOf('days')で時間設定を00:00:00にする

      const filterList = subsidyList.filter(
        (s) =>
          moment(s.availableData.receptionDateFrom).isSameOrBefore(today, 'day') &&
          moment(s.availableData.receptionDateTo).isSameOrAfter(today, 'day') &&
          moment(s.availableData.applicableDateFrom).isSameOrBefore(today, 'day') &&
          moment(s.availableData.applicableDateTo).isSameOrAfter(today, 'day') &&
          this.checkWithinLimApplicableDate(s.availableData.priceList, today)
      )
      return filterList;
    },
    /**
     * 申込日が限定適用期間内か判定する
     * @param {Array<object>} priceList 補助金単価リスト
     * @param {moment} today 申込日
     * @return {Boolean} 申込期間内：true, 申込期間外：false
     */
     checkWithinLimApplicableDate(priceList, today) {
      if (priceList && priceList.length > 0) {
        // 1つでも申込日を含む限定適用期間があれば利用可能と判定する
        const len = priceList.length
        for (let i = 0; i < len; i++) {
          const price = priceList[i];
          if (moment(price.limApplicableDateFrom).isSameOrBefore(today, 'day') &&
            moment(price.limApplicableDateTo).isSameOrAfter(today, 'day')) {
            return true;
          }
        }
      }
      return false;
    },
    /**
     * 利用可能補助金のID一覧を作成
     * @param {Array<object>} subsidyList 利用可能な補助金の一覧
     * @return {Array<string>} 利用可能な補助金のID一覧
     */
     makeSubsidyIdList(subsidyList) {
      let ids = [];
      const len = subsidyList.length;
      for (let i = 0; i < len; i++) {
        const subsidy = subsidyList[i].availableData,
          id = subsidy.subsidyId;
        ids.push(id);
      }
      return ids;
    },
    /**
     * 補助金のマッピングを取得する
     * @param {Array<string>} subsidyIds 利用可能な補助金のID一覧
     * @return {Array<string>} 補助金のマッピング結果
     */
    async getMapping(subsidyIds) {

      let params = {
        id: subsidyIds.join("-"), // 補助金ID
        targetType: "0", // 補助金
        catLrgClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catLrgClassCd || '', // 大カテゴリID
        catMidClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catMidClassCd || '', // 中カテゴリID
        catSmlClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catSmlClassCd || '', // 小カテゴリID
        menuNo:  this.menu?.menuBasicInfo?.menuNo || '',// メニューNo
        planId: this.planDetail?.planBasicInfo?.planId || '', // プランID
        receivableFlag:this.planDetail?.planUsage?.usageDetail?.receivableFlag || '1', // 売掛金フラグ(0:売掛金未対応, 1:売掛金対応)
        ticketExclusionFlag: this.planDetail?.planUsage?.usageDetail?.ticketExclusionFlag || '0', // チケット除外フラグ(0:対象外, 1:対象)
        buppanExclusionFlag: this.planDetail?.planUsage?.usageDetail?.buppanExclusionFlag || '0', // 物販除外フラグ(0:対象外, 1:対象)
        famiExclusionFlag: this.planDetail?.planUsage?.usageDetail?.famiExclusionFlag || '0' // ファミポート除外フラグ(0:対象外, 1:対象)
      };
      const res = await this.$repositories("coupon").getStationMapping(params);
      // API実行エラーの場合
      if (res.isError) {
        this.loading(false);
        this.$router.push("/404");
        return;
      }
      return res.bsSubsidyMappingArray;
    },
    /**
     * プランで利用可能な補助金一覧を作成する
     * @param {Array<string>} subsidyList 利用可能な補助金の一覧
     * @param {Array} mappingList 補助金のマッピング結果
     * @param {Array} ids 利用可能な補助金のID一覧
     * @return {Array<object>} プランで利用可能な補助金一覧
     */
    makeSubsidyList(subsidyList, mappingList, ids) {
      let subsidy = [];
      const len = mappingList.length;
      for (let i = 0; i < len; i++) {
        const id = mappingList[i].subsidyId;
        const idxSubsidyId = subsidyList.findIndex(x=> x?.availableData?.subsidyId === id);
        if (idxSubsidyId > -1) {
          // 補助金一覧に存在する場合
          subsidy.push(subsidyList[idxSubsidyId]);
        }
      }
      this.sortSubsidyList(subsidy);
      return subsidy;
    },
    /***
     * 補助金一覧の並び替え(現在が含まれる限定適用期間のTOの早い順)
     * @param {Array<object>} 補助金の情報一覧
     */
    sortSubsidyList(subsidyList) {
      // 申込日が含まれる限定適用期間のTOの早い順にする
      subsidyList.sort((a, b) => {
        const aPrice = this.getPriceLimApplicableDateIncludeToday(a.availableData.priceList);
        const bPrice = this.getPriceLimApplicableDateIncludeToday(b.availableData.priceList);
        if (aPrice && aPrice.limApplicableDateTo && bPrice && bPrice.limApplicableDateTo) {
          return new Date(aPrice.limApplicableDateTo) - new Date(bPrice.limApplicableDateTo)
        }
        return 0;
      })
    },
    /***
     * 申込日が限定適用期間に含まれるを持つ補助金単価情報の取得
     * @param {Array<object>} 補助金単価情報一覧
     * @return {object} 補助金単価情報
     */
    getPriceLimApplicableDateIncludeToday(priceList) {
      const today = moment().startOf('days'); // 日付比較のため.startOf('days')で時間設定を00:00:00にする
      if (priceList && priceList.length > 0) {
        // 申込日が限定適用期間に含まれる補助金単価情報を返す
        const len = priceList.length;
        for (let i = 0; i < len; i++) {
          const price = priceList[i];;
          if (moment(price.limApplicableDateFrom).isSameOrBefore(today, 'day') &&
            moment(price.limApplicableDateTo).isSameOrAfter(today, 'day')) {
            return price;
          }
        }
      }
      return null;
    },
    // checkFiveDay() {
    //   const countDay = moment().diff(moment(this.planRcSttDt, 'DD/MM/YYYY'), 'days')
    //   if (countDay > 0 && countDay <= 5) {
    //     return true
    //   }
    //   return false
    // },
    backPath() {
      const { menuNo } = this.$route.params
      this.$router.push({ path: `/dp/menus/${menuNo}/plans` })
    },
    setShowPattern() {
      if (this.planServiceDiv == this.CONST_DATA.SRVIC_DIV.ENTERTAINMENT) {
        // 興行の場合
        this.pattern = this.patternList.entertainment;
      } else if (this.planUsageDiv == this.CONST_DATA.USAGE_DIV.MEMBERSHIP_COUPON) {
        // 会員証クーポンの場合
        this.pattern = this.patternList.memberCoupon;
      } else if (
        this.planUsageDiv == this.CONST_DATA.USAGE_DIV.APPLY_DIRECTLY_TO_MEMBER_STORE &&
        !!this.planDetail?.usageDetailLife?.affiliateTypeId
      ) {
        // アフィリエイト
        this.pattern = this.patternList.affiliate;
      } else if (this.planUsageDiv == this.CONST_DATA.USAGE_DIV.APPLY_DIRECTLY_TO_MEMBER_STORE || this.planUsageDiv == this.CONST_DATA.USAGE_DIV.NOT_AVAILABLE_WEB) {
        // 直接申込
        this.pattern = this.patternList.direct;
      } else if (this.planUsageDiv == this.CONST_DATA.USAGE_DIV.TEXT_GUIDANCE) {
        // テキスト案内の場合
        this.pattern = this.patternList.textGuide;
      } else if (this.planUsageDiv == this.CONST_DATA.USAGE_DIV.CONVENIENCE_STORE_TERMINAL) {
        // コンビニの場合
        this.pattern = this.patternList.convenienceStore;
      } else if (this.planUsageDiv == this.CONST_DATA.USAGE_DIV.POINT_REDEMPTION) {
        // ポイント交換の場合
        this.pattern = this.patternList.pointExchange;
      } else {
        // デジチケ・デジポン
        this.pattern = this.patternList.digiTicketOrDigiCoupon;
      }
    },
        //===========================
    // 加盟店申込 申込みボタン押下
    //===========================
    merchantApply() {
      if (!this.isMerchantApplication && !this.isDirectApplication) {
        // アフィリエイト以外
        return;
      }
      // 個人情報同意モーダル表示
      this.$refs["personal-infomation"].showModal("personal-infomation");
    },
        // ショッピングガイドの表示、非表示高さ取得・調整
    getHiddenHeight: function(flg) {
      this.$nextTick(function() {
        if (typeof flg === "boolean") {
          this.isShowInfomation = flg;
        }
        if (!this.$refs.infomationText) return;
        let infomationText = this.$refs.infomationText;
        const rectText = infomationText.getBoundingClientRect();
        if (rectText.height > 64) {
          this.openHeight = this.isShowInfomation ? rectText.height : 64;
          this.isShowToggle = true;
        } else {
          this.openHeight = rectText.height;
          this.isShowToggle = false;
        }
      });
    },
    scrollToTarget(flg) {
      if (flg) {
        let targetY = this.$refs.infomationText.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: targetY
        })
      }
    },
     /**
     * 利用可能補助金アイコン取得を行う
     * @param {Array} subsidyIds プランで利用可能な補助金一覧
     */
     async getSubsidyIcon(subsidyIds) {
      const params = {
        idData: this.makeIconReqParamsSubsidyInfo(subsidyIds),
        iconData: this.makeIconReqParamsPlanInfo()
      };
      const res = await this.$repositories("coupon").getIcons(params);
      if (res?.data?.availableIcon && res?.data?.availableIcon?.[0]) {
        this.iconData.push(res.data.availableIcon[0]);
      }
    },
    /**
     * カフェのアイコンアイコン取得を行う
     * @param {Array} カフェの契約IDで利用可能なアイコンを取得する
     *  => 契約IDはBFFでログイン情報から取得する
     */
    async getCafeIcon() {
      const idData = [
        {
          no: "0", 
          targetType: "1",
          id: "0000000" // 仮の値の為、BFFでカフェの契約IDをセットすること
        }
      ];
      const params = {
        idData: idData,
        iconData: this.makeIconReqParamsPlanInfo()
      };
      const res = await this.$repositories('coupon').getIcons(params);
      if (res.data.availableIcon) {
        this.iconData.push(res.data.availableIcon[0]);
      }
    },
    /**
     * 利用可能アイコン取得のリクエストパラメータidData(補助金一覧)を生成する
     * @param {Array<string>} subsidyList このプランで利用可能な補助金一覧
     * @return {Array} 作成したidDataの配列
     */
     makeIconReqParamsSubsidyInfo(subsidyList) {
      let idData = [];
      const len = subsidyList.length;
      for (let i = 0; i < len; i++) {
        idData.push({
          no: i, // UI側で重複しない値を設定する(識別用)
          targetType: "0",
          id: subsidyList[i].availableData.subsidyId
        });
      }
      return idData;
    },
    /**
    * 利用可能アイコン取得のリクエストパラメータiconData(プラン情報一覧)を生成する
    * @return {Array} 作成したiconDataの配列
    */
    makeIconReqParamsPlanInfo() {
      const iconData = [
        {
          no: 0,
          catLrgClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catLrgClassCd || '',
          catMidClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catMidClassCd || '',
          catSmlClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catSmlClassCd || '',
          menuNo: this.menu?.menuBasicInfo?.menuNo || '',
          planId: this.planDetail?.planBasicInfo?.planId || '',
          areaLrgClassCd: this.menu?.menuBasicInfo?.areaInfomation?.areaLrgClassCd || '',
          areaMidClassCd:  this.menu?.menuBasicInfo?.areaInfomation?.areaMidClassCd || '',
          areaSmlClassCd:  this.menu?.menuBasicInfo?.areaInfomation?.areaSmlClassCd || '',
          areaDtlClassCd:  this.menu?.menuBasicInfo?.areaInfomation?.areaDtlClassCd || '',
          receivableFlag: '1',
          ticketExclusionFlag: this.planDetail?.planUsage?.usageDetail?.ticketExclusionFlag || '0',
          buppanExclusionFlag: this.planDetail?.planUsage?.usageDetail?.buppanExclusionFlag || '0',
          famiExclusionFlag: this.planDetail?.planUsage?.usageDetail?.famiExclusionFlag || '0'
        }
      ];
      return iconData;
    },
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
@import './p-menus-no-detail-infomation.scss';
@import './p-menus-no-plan-detail.scss';
@import './c-text-button.scss';
</style>
